var exports = {
  "az": "Box__HICM1B",
  "re": "GitHubAvatar__JZ6HU4",
  "EY": "Text__tjJmgt",
  "$n": "Button__Gr8pjo",
};

module.exports = exports;
